module.exports = __webpack_public_path__ + "img/crew-img-1.d90f10ac.png";